import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./i18n/i18n"; // Import i18n configuration
import App from "./App";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Could not find root element");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
